var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"top-section",attrs:{"aria-label":_vm.$t('top_section.title')}},[(!_vm.isMobileDevice)?_c('DesktopVersion'):_c('MobileVersion')],1)}
var staticRenderFns = []

export { render, staticRenderFns }